export const SPACES = {
  padding: {
    primary: '30px',
    primary2: '60px',
    primary3: '90px',
    primary4: '120px',
    primary5: '0px',
  },
}
